/**
 * Текущее разрешение пользователя на web-push уведомления.
 *
 * Возвращает нативное значение `Notification.permission` (`'default' | 'granted' | 'denied'`),
 * а в окружении без Notification API (SSR, старые браузеры) — `'not_supported'`.
 */
export const getWebPushPermission = (): NotificationPermission | 'not_supported' =>
    // eslint-disable-next-line compat/compat
    typeof Notification !== 'undefined' ? Notification.permission : 'not_supported';
